import {
    convertToDateFormat, RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer, RaikoConfirmDialog, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoDatePicker,
    RaikoGridFourColumn,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoTimePicker, showErrorMessage,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {Chip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {ElectionService} from "../../serverService/electionService/ElectionService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useParams} from "react-router-dom";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function ElectionBasicInfo() {


    const [title, setTitle] = useState("");
    const [groupName, setGroupName] = useState("");
    const [groupId, setGroupId] = useState("");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");
    const [publish, setPublish] = useState(false);
    const [status, setStatus] = useState(false);
    const [candidatesList, setCandidatesList] = useState([]);
    const [description, setDescription] = useState("");

    const {fundID} = useAuthState()
    const {id: electionId} = useParams()


    const service = new ElectionService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        getElectionBasicInfoFromServer()
    }, [fundID]);


    function getElectionBasicInfoFromServer() {
        loading.show()
        service.getElectionBasicInfo(fundID, electionId).then(
            response => {
                setTitle(response.title)
                setGroupName(response.groupName)
                setGroupId(response.groupId)
                setStartDate(convertToDateFormat(response.startPersianDate))
                setStartTime(response.startPersianTime)
                setPublish(response.published)
                setStatus(response.enabled)
                setEndDate(response.endPersianDate)
                setEndTime(response.endPersianTime)
                setDescription(response.description)
                setCandidatesList([])
                response.candidates.map((item, index) => {
                    setCandidatesList((prevState => [...prevState, {
                        key: item.id,
                        label: item.title
                    }]))
                })

            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [disableElection, setDisableElection] = useState(false);


    function handleOpenDisableElectionDialog() {
        setDisableElection(true)
    }

    function handleCloseDisableElectionDialog() {
        setDisableElection(false)
    }

    function handleDisableElection() {
        loading.show()
        service.disableElection(fundID, electionId).then(
            response => {
                showSuccessMessage("انتخابات با موفقیت لغو شد.")
                handleCloseDisableElectionDialog()
                setStatus(false)
                // getElectionBasicInfoFromServer()
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [endElection, setEndElection] = useState(false);


    function handleOpenEndElectionDialog() {
        setEndElection(true)
    }

    function handleCloseEndElectionDialog() {
        setEndElection(false)
    }

    function handleEndElection() {
        loading.show()
        service.endElection(fundID, electionId).then(
            response => {
                showSuccessMessage("انتخابات با موفقیت پایان یافت.")
                handleCloseEndElectionDialog()
                getElectionBasicInfoFromServer()
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateElection() {
        if (endTime.length > 0 && endDate.length > 0) {
            loading.show()
            service.updateElectionEndTimeDate(
                fundID,
                groupId,
                electionId,
                title,
                startDate,
                startTime,
                endDate,
                endTime,
                publish,
                candidatesList,
                description,
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا تاریخ و زمان پایان انتخابات را به درستی وارد نمایید.")
        }
    }

    return (
        <>
            <RaikoConfirmDialog
                cancelAction={handleCloseDisableElectionDialog} openConfirmDialog={disableElection}
                doAction={handleDisableElection}
                pageTitle={"لغو انتخابات"}
                warningTitle={"آیا از این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={"لغو انتخابات"}
            />
            <RaikoConfirmDialog
                cancelAction={handleCloseEndElectionDialog} openConfirmDialog={endElection}
                doAction={handleEndElection}
                pageTitle={"پایان انتخابات"}
                warningTitle={"آیا از این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={"پایان انتخابات"}
            />
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                    >
                        <RaikoGridOneColumn>
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"عنوان"}
                                    value={title}
                                    setValue={setTitle}
                                    disabled={true}
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"گروه"}
                                    value={groupName}
                                    setValue={setGroupName}
                                    disabled={true}
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"تاریخ شروع"}
                                    value={startDate}
                                    setValue={setStartDate}
                                    disabled={true}
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"زمان شروع"}
                                    value={startTime}
                                    setValue={setStartTime}
                                    disabled={true}
                                />

                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={publish}
                                    setValue={setPublish}
                                    disabled={true}
                                    items={[
                                        raikoCustomSelectItemGenerator(true, "منتشر شده"),
                                        raikoCustomSelectItemGenerator(false, "عدم انتشار")
                                    ]}
                                />
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={status}
                                    setValue={setStatus}
                                    disabled={true}
                                    items={[
                                        raikoCustomSelectItemGenerator(true, "فعال"),
                                        raikoCustomSelectItemGenerator(false, "غیر فعال")
                                    ]}
                                />
                            </RaikoGridThreeColumn>

                            <section className={css`display: flex;
                              flex-direction: column;
                              gap: 1rem`}>
                                <label
                                    className={candidatesList.length > 0 ? css`display: block` : css`display: none`}>کاندیدها</label>
                                <div className={css`display: flex;
                                  flex-direction: row;
                                  gap: 1rem`}>
                                    {candidatesList.map((data) => {
                                        return (
                                            <Chip
                                                label={data.label}
                                                key={data.key}
                                            />
                                        )
                                    })}
                                </div>
                            </section>
                            <RaikoSimpleMultiLineInputOutlined
                                labelText={"توضیحات"}
                                value={description}
                                setValue={setDescription}
                                disabled={true}
                            />
                        </RaikoGridOneColumn>

                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات قابل تغییر"}
                        hasActionButton={status}
                        actionButtonTitle={"تمدید انتخابات"}
                        actionButtonOnclick={handleUpdateElection}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDate}
                                setDate={setEndDate}
                            />
                            <RaikoTimePicker
                                label={"زمان پایان"}
                                time={endTime}
                                setTime={setEndTime}
                            />
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"لغو انتخابات"}
                        hasActionButton
                        actionButtonTitle={"لغو انتخابات"}
                        actionButtonOnclick={handleOpenDisableElectionDialog}
                    >
                        <RaikoAlert
                            title={"لطفا قبل از ادامه به نکات زیر توجه فرمایید."}
                            type={raikoAlertTypes.warning}
                            description={[
                                "با لغو انتخابات امکان فعال سازی مجدد انتخابات وجود نخواهد داشت.",
                            ]}
                        />
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"پایان انتخابات"}
                        hasActionButton
                        actionButtonTitle={"پایان انتخابات"}
                        actionButtonOnclick={handleOpenEndElectionDialog}
                    >
                        <RaikoAlert
                            title={"لطفا قبل از ادامه به نکات زیر توجه فرمایید."}
                            type={raikoAlertTypes.warning}
                            description={[
                                "با پایان انتخابات امکان فعال سازی مجدد انتخابات وجود نخواهد داشت.",
                            ]}
                        />
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>

        </>

    )
}